export enum ClubFacilitiesStyle {
  RICH_GRAY = 'rich-gray',
  GRAY = 'gray',
  PALE_GREEN = 'pale-green',
  LIGHT = 'light',
  WHITE = 'white',
}
